import { ProductType } from "@/constants/ProductType";
import { z } from "zod";
import { TankPlanModelSchema } from "../dischargePlan/types";
import { DomainModelSchema, PaginationSchema } from "../types";

export const ReceiptPlanModelSchemaV2 = DomainModelSchema.extend({
  planId: z.number(),
  amountInKiloLitres: z.number(),
  product: z.nativeEnum(ProductType),
  balance: z.number(),
  tankPlans: z.array(TankPlanModelSchema),
});

export type ReceiptPlanModelV2 = z.infer<typeof ReceiptPlanModelSchemaV2>;

export const ListReceiptPlanResponseModelSchema = z.object({
  pagination: PaginationSchema,
  data: z.array(ReceiptPlanModelSchemaV2),
});

export type ListReceiptPlanResponse = z.infer<
  typeof ListReceiptPlanResponseModelSchema
>;
